<!--
@component Button with text.

   Main properties:
   - `text` - text on the button.
   - `onclick` - function (callback) to be called when user clicks on the button.
-->
<script>
   let {text = 'button', onclick} = $props();
</script>

<button tabindex="0" class="button" {onclick}>{text}</button>

<style>
   button {
      display: inline-block;
      font-size: 0.9em;
      padding: 0em 0.5em;
      line-height: 1.5em;
      border-radius: 0.25em;
      box-shadow: none;
      margin: 0;
      text-align: center;
      border: 1px solid;
   }

   .button:focus-visible {
      outline: solid 2px;
      outline-offset: 2px;
   }

</style>
